import { rgba } from 'polished';
import styled from 'styled-components';
import { palette, theme } from 'styled-tools';
import { fontFamily, fontSize, fontWeight, FontWeights, lineHeight, } from '../../utils/typography';
import { Wrapper as LoaderWrapper } from '../Loader/styles';
export const Wrapper = styled.button `
	background: transparent;
	text-decoration: ${p => (p.$hideUnderline ? 'none' : 'underline')};
	border: none;
	padding: 0;
	margin: 0;
	border: none;
	color: ${props => rgba(
// eslint-disable-next-line no-nested-ternary
props.disabled ? '#C6C6C6' : palette(props.$textColor)(props), props.$isLoading ? 0.25 : 1)};
	display: inline-block;
	${fontFamily};
	${p => (p.$size ? fontSize(p.$size) : '')};
	${p => (p.$size ? lineHeight(p.$size) : '')};
	${p => { var _a; return fontWeight((_a = p.$weight) !== null && _a !== void 0 ? _a : FontWeights.Medium); }};
	position: relative;
	transition: ${theme('animation.transition')};
	z-index: 0;
	cursor: ${props => (props.disabled ? 'initial' : 'pointer')};

	${LoaderWrapper} {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translateX(-50%) translateY(-50%);
		width: 100%;
	}
`;
//# sourceMappingURL=styles.js.map